export default __webpack_public_path__ + "static/media/011-jewelry store.99512a9b.svg";